export const DOT_SIZE_REM = 0.75;
export const DOT_SPACING_REM = 0.5;
export const DOT_STEP_REM = DOT_SIZE_REM + DOT_SPACING_REM;
export const MAX_VISIBLE_DOTS = 5;
export const CENTER_DOT_INDEX = 2;
